import { _ } from "../../../core/polyglot/polyglot.js";

/**
 * `CommandHeading` is a model used to encapsulate a command's
 * heading. `CommandHeading` acts as a Flyweight to prevent having
 * headings with the same name but different priorities.
 */
class CommandHeading {
	constructor({ name = "", translation = "", priority = 0 }) {
		this._name = name;
		this._translation = translation;
		this._priority = priority;
	}

	getName() {
		return this._name;
	}

	getTranslation() {
		return this._translation;
	}

	priority() {
		return this._priority;
	}
}

// Map heading names to their heading:
const nameToHeading = {};

function storeNewCommandHeading(name, translation, priority) {
	nameToHeading[name] = new CommandHeading({
		name,
		translation,
		priority,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export default function getNamedCommandHeading(name) {
	return nameToHeading[name];
}

storeNewCommandHeading("Administrative", _("Administrative"), 10);
storeNewCommandHeading("Folder", _("Folder"), 100);
storeNewCommandHeading("Actions", _("Actions"), 200);
